/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { QuestionAnswer } from './questionAnswer';
import type { ConceptGraphInput } from './conceptGraphInput';
import type { ContentStudioStage2RequestConfig } from './contentStudioStage2RequestConfig';

/**
 * Input: The user's selected scope and answers to scoping questions.
 */
export interface ContentStudioStage2Request {
  selectedNodeIds: string[];
  answers: QuestionAnswer[];
  originalPrompt: string;
  graph: ConceptGraphInput;
  config?: ContentStudioStage2RequestConfig;
}
